import { Button } from 'components/atoms/Button';
import type { FC } from 'react';
import Lottie from 'react-lottie';
import { useTranslation } from 'react-i18next';
import useCustomNavigate from 'hooks/useCustomeNavigate';
import type { ActivationStepProps } from '../../types';
import { OnboardingStepWrapper } from 'components/organisms/OnboardingStepLayout';
// todo: fix the cycle import if possible
import StepsProgressSummary from '../../../components/StepsProgressSummary';
import confettiAnimation from './Confetti-new.json';

/**
 * Final completion screen for activation flow
 * Shows all completed steps with animated checkmark on the last completed item (Embed banking)
 * Includes celebratory confetti animation
 * Similar to InitActivationStep but showing all completed steps
 * Redirects to /banks on completion
 */
const ReadyToGoStep: FC<ActivationStepProps> = ({
  onContinue,
  // Wrapper props (automatically injected)
  progressSegments,
  onProgressSegmentClick,
  title,
  subtitle,
  icon,
  showProgressBar,
  isUpdatingStep,
}) => {
  const { t } = useTranslation();
  const navigate = useCustomNavigate();

  const handleComplete = () => {
    onContinue();
    // Navigate to banks page
    setTimeout(() => {
      navigate('/banks');
    }, 300);
  };

  return (
    <OnboardingStepWrapper
      showProgressBar={showProgressBar}
      progressSegments={progressSegments}
      onProgressSegmentClick={onProgressSegmentClick}
      icon={icon}
      title={title}
      subtitle={subtitle}
    >
      {/* Confetti celebration animation */}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center z-0">
        <Lottie
          options={{
            loop: 1,
            autoplay: true,
            animationData: confettiAnimation,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid meet',
            },
          }}
          height={400}
          width={400}
        />
      </div>

      <div className="my-5 relative z-10">
        {/* Dynamic summary showing all main steps with animated checkmark on "Embed banking" */}
        <StepsProgressSummary
          currentSubstepId="ready_to_go"
          mode="all"
          animateStepId="embed_banking"
        />
      </div>

      <Button
        onClick={handleComplete}
        className="w-full mt-3 relative z-10"
        color="bank"
        disabled={isUpdatingStep}
      >
        {t('continue')}
      </Button>
    </OnboardingStepWrapper>
  );
};

export default ReadyToGoStep;
